import AcronisBackupSettings from './Acronis';

export default AcronisBackupSettings;
